import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/app/services/api.service';
import { ThemeService } from 'src/app/services/theme.service';
import { FeatureFlagService } from 'src/app/services/feature-flag.service';

@Component({
    selector: 'app-accept-updated-terms',
    templateUrl: './accept-updated-terms.component.html',
    styleUrls: ['./accept-updated-terms.component.scss'],
    standalone: false
})
export class AcceptUpdatedTermsComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AcceptUpdatedTermsComponent>,
    private api: ApiService,
    public themeService: ThemeService,
    private featureFlagService: FeatureFlagService
  ) { }

  assets = environment.assets;
  accepted = false;
  loading = true;
  termsContent = '';
  displayName = '';

  ngOnInit(): void {
    // Use "Mission Specialty Consults" if specialty intake is enabled, otherwise use theme display name
    if (this.featureFlagService.isSpecialtyIntakeEnabled()) {
      this.displayName = 'Mission Specialty Consults';
    } else {
      this.displayName = this.themeService.getDisplayName();
    }
    this.loadTermsContent();
  }

  loadTermsContent(): void {
    this.loading = true;
    this.api.apiRequest('get', 'user/termsContent', {}).subscribe({
      next: (res) => {
        this.loading = false;
        if (res && res.data) {
          this.termsContent = res.data.termsContent || '';
        }
      },
      error: (err) => {
        this.loading = false;
        console.error('Error loading terms content:', err);
      }
    });
  }

  modalClose = (close = 'X') => {
    this.dialogRef.close(close);
  }

}
